<script lang="ts">
	// eslint-disable-next-line no-restricted-imports
	import { Toggle } from "flowbite-svelte";
	import { twJoin } from "tailwind-merge";
	import type { ComponentProps } from "svelte";

	type $$Props = ComponentProps<Toggle>;

	export let checked: boolean | undefined = undefined;
	export let group: string[] = [];
</script>

<Toggle class={twJoin("inline-flex", $$props.class)} classDiv={twJoin(!$$slots.default && "me-0", $$props.classDiv)} bind:checked bind:group on:click on:change {...$$restProps}>
	<slot />
</Toggle>
